var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D7F3DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 18.5149C22.4669 18.5149 24.4429 16.524 24.4429 14.0577C24.4429 11.5914 22.4669 9.60059 20.0006 9.60059C17.5343 9.60059 15.5434 11.5914 15.5434 14.0577C15.5434 16.524 17.5343 18.5149 20.0006 18.5149ZM20.0006 21.4863C16.5389 21.4863 9.60059 23.2246 9.60059 26.6863V30.4006H30.4006V26.6863C30.4006 23.2246 23.4623 21.4863 20.0006 21.4863Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBill);
export default __webpack_public_path__ + "static/media/single_bill.161ff16998985c6e4beacc33d36e2d5b.svg";
export { ForwardRef as ReactComponent };